import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { DelayedQuoteResponse } from 'src/app/models/market-data-response.model'

@Injectable({
  providedIn: 'root',
})
export class MarketDataService {
  public static readonly delayedPriceEndpoint = '/delayedPrice'

  constructor(private readonly http: HttpClient) {}

  getMarketPrice(fundId: string): Observable<DelayedQuoteResponse> {
    return this.http.get<DelayedQuoteResponse>(
      `vmf/api/${fundId}`.concat(MarketDataService.delayedPriceEndpoint),
    )
  }
}
